import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "max-w-114" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = {
  key: 0,
  class: "text-lighter text-xs"
}
const _hoisted_4 = { class: "capitalize" }
const _hoisted_5 = ["value"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    value: {},
    memberColour: {},
    memberSince: {},
    nextLevel: {}
  },
  setup(__props: any) {

const props = __props;

const daysAsMember = props.memberSince
  ? Math.round((Date.now() - props.memberSince.getTime()) / (1000 * 60 * 60 * 24))
  : null;
const yearsAsMember = props.memberSince && daysAsMember ? Math.floor(daysAsMember / 365) : 0;
const timeSpan =
  !props.memberSince || yearsAsMember == null || !daysAsMember
    ? '1 day' /** special case for first day member before 10am */
    : yearsAsMember > 0
      ? `${yearsAsMember} year${yearsAsMember > 1 ? 's' : ''}`
      : `${daysAsMember} day${daysAsMember > 1 || daysAsMember == 0 ? 's' : ''}`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _createElementVNode("span", {
          class: _normalizeClass(["font-sans font-medium mr-2 capitalize", `text-member-${_ctx.memberColour}`])
        }, _toDisplayString(_ctx.memberColour), 3),
        _createElementVNode("span", null, _toDisplayString(_unref(timeSpan)), 1)
      ]),
      (_ctx.nextLevel)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Next level", -1)),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.nextLevel), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("progress", {
      max: "100",
      value: _ctx.value,
      class: _normalizeClass(["rounded-full h-2 w-full", `[&::-moz-progress-bar]:bg-progress-${_ctx.memberColour}-member [&::-webkit-progress-value]:bg-progress-${_ctx.memberColour}-member`])
    }, null, 10, _hoisted_5)
  ]))
}
}

})